
import { FRENCH_DEPARTMENTS } from "../constants/departements";

// Converts a department name as it appears in access rights
// ("Pas-de-Calais"..) to ("pasdecalais"..).
export const toBackendDepartmentCode = (department) => {
  if (!department) return department;

  return department
    .normalize("NFD") // split accented chars into base char + accent mark
    .replace(/[\u0300-\u036f]/g, "") // strip the accent marks
    .replace(/[^a-zA-Z0-9]/g, "") // drop hyphens, apostrophes, spaces, etc.
    .toLowerCase();
};

// { "pyreneesatlantiques": "Pyrénées-Atlantiques", "valdoise": "Val-d'Oise", ... }
const DEPARTMENT_LABEL_MAP = FRENCH_DEPARTMENTS.reduce((map, label) => {
  map[toBackendDepartmentCode(label)] = label;
  return map;
}, {});

// Looks up the properly-accented display label from a raw backend code
// (or any variant — it re-normalizes before matching, so it's safe to
// pass "pyreneesatlantiques", "PyreneesAtlantiques", etc.)
// Falls back to the original input if no match is found.
export const fromBackendDepartmentCode = (code) => {
  if (!code) return code;
  return DEPARTMENT_LABEL_MAP[toBackendDepartmentCode(code)] || code;
};